
  export const MILESTONES_RECEIVED = "MILESTONES_RECEIVED";
  export const SET_MILESTONE = "SET_MILESTONE";
  export const CREATE_MILESTONE = "CREATE_MILESTONE";
  export const SET_PROPERTY_MILESTONE = "SET_PROPERTY_MILESTONE";
  